import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { BanIcon, WifiSlashIcon } from '@ninja/icons/web';
import { IToastProps, useToast } from '@ninja/web';
import { GlobalAPIError } from '@shory-health-individual/customer-lib';

export const useToastApiError = () => {
	const { showError } = useToast();
	const { t } = useTranslation();

	const showToastApiError = useCallback(
		(error?: GlobalAPIError) => {
			const errorsOptions: { [k: string]: IToastProps } = {
				NetworkConnection: {
					title: t('shared.error-messages.network-connection'),
					icon: WifiSlashIcon,
				},
			};

			let toastErrorOptions: IToastProps | undefined = undefined;

			const errorCode = error?.mapped?.[0]?.code;

			if (errorCode) {
				toastErrorOptions = errorsOptions[errorCode];
			}

			if (!toastErrorOptions) {
				toastErrorOptions = {
					title: t('shared.error-messages.general-error'),
					icon: BanIcon,
				};
			}

			showError(toastErrorOptions);
		},
		[showError, t]
	);

	return { showToastApiError };
};
